<template>
  <div>
    <!-- Ticket Card - Compact View -->
    <v-card v-if="isOpen" flat :disabled="isDisabled" :class="`ticket-card ${dialog ? 'grey lighten-4' : color}`"
      @click="fazerChamada">
      <v-row no-gutters align="center" class="py-2 px-1">
        <!-- Icon Column -->
        <v-col cols="2" class="text-center">
          <v-icon large :color="dialog ? 'grey darken-1' : colorText">
            mdi-ticket-account
          </v-icon>
        </v-col>

        <!-- Number Column (now with transparent background) -->
        <v-col cols="7" class="text-center">
          <div class="text-caption mb-n2" :class="`${colorText}--text`">SENHA</div>
          <div class="number-display" :class="`${colorText}--text`">
            {{ propriedade }}{{ codigo | formatCode }}
          </div>
        </v-col>

        <!-- Time Column -->
        <v-col cols="3" class="text-center">
          <v-chip small color="white" text-color="black" class="time-chip">
            <v-icon x-small left>mdi-clock-outline</v-icon>
            <span class="caption">{{ dataChegada }}</span>
          </v-chip>
        </v-col>
      </v-row>
    </v-card>

    <!-- Ticket Card - Minimal View -->
    <v-card v-else :class="`ticket-card-minimal`" outlined @click="fazerChamada">
      <v-row no-gutters align="center" class="py-1 px-1">
        <v-col cols="8" class="text-center">
          <span :class="`title font-weight-bold grey--text text--darken-1`">
            {{ propriedade }}{{ codigo | formatCode }}
          </span>
        </v-col>

        <v-divider vertical style="background-color: #424242; opacity: 0.3" />

        <v-col cols="4" class="text-center">
            <span class="caption">{{ dataChegada }}</span>
        </v-col>
      </v-row>
    </v-card>

    <!-- Ticket Dialog - Detailed View -->
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card :color="color" class="ticket-dialog">
        <v-card-text class="pa-4">
          <!-- Header -->
          <div class="d-flex align-center mb-2">
            <v-icon large color="white">mdi-ticket-confirmation</v-icon>
            <div class="ml-3">
              <div class="text-overline white--text">ATENDIMENTO</div>
              <div class="display-2 font-weight-bold white--text">
                {{ mapearLetraPrioridade(myAtendimento.prioridade) }}{{ myAtendimento.codigo | formatCode }}
              </div>
            </div>
          </div>

          <!-- Time and Priority -->
          <div class="d-flex justify-space-between align-center white--text mb-4">
            <div>
              <v-icon small left>mdi-clock</v-icon>
              <span class="subtitle-1">{{ converterDate(myAtendimento.dataChegada) }}</span>
            </div>
            <v-chip small dark>
              {{ getPriorityLabel(myAtendimento.prioridade) }}
            </v-chip>
          </div>

          <!-- Services -->
          <v-expand-transition>
            <div v-if="servicos && isChamar">
              <v-divider class="my-3 white"></v-divider>
              <div class="white--text subtitle-1 mb-2">Serviços Solicitados</div>
              <v-chip-group column>
                <v-chip v-for="(item, index) in servicos" :key="index" color="white" :text-color="color" small
                  class="mr-1 mb-1">
                  <v-icon x-small left>mdi-check</v-icon>
                  {{ item.nomeServico }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-expand-transition>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="pa-4 pt-0">
          <v-btn color="white" text :disabled="btnOp" @click="naoCompareceu" class="action-btn">
            <v-icon left small>mdi-close-circle</v-icon>
            Não Compareceu
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="white" outlined :disabled="emChamada" @click="clickChamar" class="action-btn mr-2">
            <v-icon left small>mdi-microphone</v-icon>
            Chamar
          </v-btn>

          <v-btn color="white" :disabled="btnOp" @click="iniciarAtendimento" class="action-btn">
            <v-icon left small>mdi-account-arrow-right</v-icon>
            Iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'CodigoFicha',
  props: {
    myAtendimento: Object,
    propriedade: String,
    codigo: String,
    dataChegada: String,
    servicos: Array,
    tipo: Number,
    btnOp: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    emChamada: Boolean,
    myDisabled: {
      type: Boolean,
      default: false
    },
    isDark: {
      type: Boolean,
      default: false
    },
    markColor: {
      type: String,
      default: 'grey lighten-3'
    },
    color: {
      type: String,
      default: 'primary'
    },
    colorText: {
      type: String,
      default: 'white--text'
    },
    mDialog: {
      type: Number,
      default: 1
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatCode (value) {
      return value ? value.toString().padStart(3, '0') : '000'
    }
  },
  data () {
    return {
      isChamar: false,
      dialog: false
    }
  },
  methods: {
    iniciarAtendimento () {
      this.$emit('iniciarAtendimento', true)
      this.dialog = false
    },
    naoCompareceu () {
      this.$emit('naoCompareceu', true)
      this.dialog = false
    },
    clickChamar () {
      this.$emit('chamar', '')
    },
    fazerChamada () {
      this.isChamar = true
      this.dialog = true
      if (this.tipo == 1) {
        this.$emit('add-atendimento')
      }
    },
    mapearLetraPrioridade (prioridade) {
      const priorityMap = {
        0: 'C',
        1: 'P',
        2: 'B',
        3: 'A'
      }
      return priorityMap[prioridade] || 'C'
    },
    getPriorityLabel (prioridade) {
      const labels = {
        0: 'Normal',
        1: 'Prioritário',
        2: 'Idoso',
        3: 'Deficiente'
      }
      return labels[prioridade] || 'Normal'
    },
    converterDate (data) {
      if (!data) return '--:--'
      const d = new Date(data)
      return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.ticket-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.ticket-card:hover:not(.v-card--disabled) {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
}

.ticket-card-minimal {
  transition: all 0.2s ease;
  border-radius: 8px !important;
}

.ticket-card-minimal:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.ticket-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.action-btn {
  border-radius: 8px;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
}

.display-1,
.display-2 {
  letter-spacing: 1px;
  line-height: 1.1;
}

/* Animation for priority letters */
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.ticket-card .display-1 {
  animation: pulse 2s infinite;
}

.ticket-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
}

.ticket-card:hover:not(.v-card--disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.number-display {
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.time-chip {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.v-divider {
  opacity: 0.2;
  height: 40px;
  align-self: center;
}
</style>
